import { useContext } from "react";
import {
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import EditIcon from "@mui/icons-material/Edit";
import FavoriteIcon from "@mui/icons-material/Favorite";


const EventProfiles = ({eventProfiles, handleSelect}) => {
    


  return (
    <Grid item xs={12}>
      <Paper height={3}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
           
          >
            <ListItemButton style={{fontWeight: 'bold'}}>Event Profiles</ListItemButton>
          </AccordionSummary>

          <AccordionDetails>
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              {eventProfiles.map((p) => {
                return (
                  <ListItemButton key={p._id} onClick={() => handleSelect(p._id)}>
                    <ListItemIcon>
                      <EditIcon />
                    </ListItemIcon>
                    <ListItemText primary={p?.name} />
                  </ListItemButton>
                );
              })}

            </List>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Grid>
  );
};

export default EventProfiles;
